import { render } from "./RouteLoading.vue?vue&type=template&id=532d27f6"
const script = {}

import "./RouteLoading.vue?vue&type=style&index=0&id=532d27f6&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__